import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";
import { useAuth } from "@/context/auth-context";

export const useRequestStats = (
  promptId: string,
  version: string,
  dateRange?: { from?: Date; to?: Date },
) => {
  const auth = useAuth();
  const userToken = auth?.userToken || "";
  const { workspaceId } = useParams();
  const startTime = dateRange?.from?.toISOString();
  const endTime = dateRange?.to?.toISOString();

  return useQuery(
    [ENDPOINTS.get_request_stats_for_prompt, promptId, version, workspaceId, startTime, endTime],
    () => {
      const params = new URLSearchParams({
        prompt_id: promptId,
        version,
        workspace_id: String(workspaceId),
      });
      if (startTime) {
        params.set("start_time", startTime);
      }
      if (endTime) {
        params.set("end_time", endTime);
      }

      return fetch(`${ENDPOINTS.get_request_stats_for_prompt}?${params.toString()}`, {
        headers: authHeader(userToken),
      }).then(handleResponse);
    },
    {
      placeholderData: {
        success: false,
        stats: {
          averageLatency: 0,
          totalCost: 0,
          totalRequests: 0,
          averageScore: 0,
          totalScoredRequests: 0,
        },
      },
    },
  );
};
